import React from 'react';
import { fade, makeStyles } from '@material-ui/core/styles';
import defaultTheme from './default';

const primaryColor = defaultTheme.primaryColor;
const textTransformUppercase = defaultTheme.uppercase;
const textTransformCapitalize = defaultTheme.capitalize;
const textColor = defaultTheme.textColor;
const statusSubHeading = defaultTheme.statusSubHeading;
const useStyles = makeStyles((theme) => ({
  mainTextWidth: {
    maxWidth: '100% !important',
    flexBasis: '100 % !important'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  mainText: {
    fontWeight: 500,

    [theme.breakpoints.only('xs')]: {
      fontSize: '12px !important',
    },

    [theme.breakpoints.only('sm')]: {
      fontSize: '12px !important',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '12px !important',
    },
    [theme.breakpoints.only('lg')]: {
      fontSize: '17px !important',
    },
    [theme.breakpoints.only('xl')]: {
      fontSize: '25px !important',
    },
  },
  subText: {
    fontWeight: 400,

    [theme.breakpoints.only('xs')]: {
      fontSize: '8px !important',
    },

    [theme.breakpoints.only('sm')]: {
      fontSize: '8px !important',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '8px !important',
    },
    [theme.breakpoints.only('lg')]: {
      fontSize: '13px !important',
    },
    [theme.breakpoints.only('xl')]: {
      fontSize: '18px !important',
    },
  },
  subTextTableHead: {
    fontWeight: 500,
    [theme.breakpoints.only('xs')]: {
      fontSize: '8px !important',
    },

    [theme.breakpoints.only('sm')]: {
      fontSize: '8px !important',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '8px !important',
    },
    [theme.breakpoints.only('lg')]: {
      fontSize: '13px !important',
    },
    [theme.breakpoints.only('xl')]: {
      fontSize: '18px !important',
    },
  },
  searchIcon: {
    [theme.breakpoints.only('xs')]: {
      fontSize: '20px',
      padding: '1px',
      verticalAlign: 'middle',
    },

    [theme.breakpoints.only('sm')]: {
      fontSize: '20px',
      padding: '1px',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '20px',
      padding: '1px',
    },
    [theme.breakpoints.only('lg')]: {
      fontSize: '20px',
      padding: '3px',
    },
    [theme.breakpoints.only('xl')]: {
      fontSize: '25px',
      padding: '5px',
    },
  },
  filterIcon: {
    [theme.breakpoints.only('xs')]: {
      fontSize: '15px',
      padding: '1px',
    },

    [theme.breakpoints.only('sm')]: {
      fontSize: '20px',
      padding: '1px',
      width: '20px',
      filter: 'invert(1)',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '15px',
      padding: '1px',
      width: '20px',
      filter: 'invert(1)',
    },
    [theme.breakpoints.only('lg')]: {
      fontSize: '20px',
      padding: '3px',
      width: '20px',
      filter: 'invert(1)',
    },
    [theme.breakpoints.only('xl')]: {
      fontSize: '25px',
      padding: '5px',
      width: '20px',
      filter: 'invert(1)',
    },
  },
  searchIconBorder: {
    border: '1px solid rgba(63,142,199,1)',
    borderRadius: '5px',
  },
  searchIconXs: {
    lineHeight: '15px',
    verticalAlign: 'middle',
    margin: '5px',
    width: '20px',
    height: '22px',
    fontSize: '20px',
  },
  primaryColor: {
    color: 'rgba(63,142,199,1) !important',
  },
  dnone: {
    display: 'none',
  },
  m1: {
    margin: '8px 0px',
  },
  p1: {
    padding: '8px 0px',
  },
  gridJc: {
    textAlign: 'right',
    [theme.breakpoints.only('xs')]: {
      textAlign: 'center',
      alignItems: 'center',
    },
  },
  gridJCC: {
    [theme.breakpoints.only('xs')]: {
      justifyContent: 'center',
    },
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
  mainText: {
    fontWeight: '700 ',
    wordBreak: 'break-word',
    textTransform: 'capitalize',
    color: '#223345',
    [theme.breakpoints.only('xs')]: {
      fontSize: '14px !important',
    },

    [theme.breakpoints.only('sm')]: {
      fontSize: '14px !important',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '14px !important',
    },
    [theme.breakpoints.only('lg')]: {
      fontSize: '16px !important',
    },
    [theme.breakpoints.only('xl')]: {
      fontSize: '20px !important',
    },
  },
  mainTextDot: {
    fontWeight: '700 ',
    wordBreak: 'break-word',
    textTransform: 'capitalize',

    [theme.breakpoints.only('xs')]: {
      fontSize: '12px !important',
    },

    [theme.breakpoints.only('sm')]: {
      fontSize: '12px !important',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '14px !important',
    },
    [theme.breakpoints.only('lg')]: {
      fontSize: '16px !important',
    },
    [theme.breakpoints.only('xl')]: {
      fontSize: '20px !important',
    },
  },
  subText: {
    fontWeight: '700 ',
    wordBreak: 'break-word',
    textTransform: 'capitalize',
    color: '#A6C1D3',
    [theme.breakpoints.only('xs')]: {
      fontSize: '13px !important',
    },

    [theme.breakpoints.only('sm')]: {
      fontSize: '13px !important',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '13px !important',
    },
    [theme.breakpoints.only('lg')]: {
      fontSize: '14px !important',
    },
    [theme.breakpoints.only('xl')]: {
      fontSize: '20px !important',
    },
  },
  subTextButton: {
    fontWeight: '600',
    wordBreak: 'break-word',
    //color:"#adbfcd",
    [theme.breakpoints.only('xs')]: {
      fontSize: '12px !important',
    },

    [theme.breakpoints.only('sm')]: {
      fontSize: '12px !important',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '12px !important',
    },
    [theme.breakpoints.only('lg')]: {
      fontSize: '14px !important',
    },
    [theme.breakpoints.only('xl')]: {
      fontSize: '20px !important',
    },
  },
  dividerInset: {
    margin: `5px 0 0 ${theme.spacing(9)}px`,
  },

  mainBreadcrumbs: {
    fontWeight: 600,
    color: primaryColor,
    textTransform: textTransformCapitalize,
    [theme.breakpoints.only('xs')]: {
      fontSize: '16px ',
    },

    [theme.breakpoints.only('sm')]: {
      fontSize: '16px ',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '15px ',
    },
    [theme.breakpoints.only('lg')]: {
      fontSize: '14px ',
    },
    [theme.breakpoints.only('xl')]: {
      fontSize: '18px ',
    },
  },
  childBreadcrumbs: {
    fontWeight: 600,
    color: textColor,
    textTransform: textTransformCapitalize,
    [theme.breakpoints.only('xs')]: {
      fontSize: '16px ',
    },

    [theme.breakpoints.only('sm')]: {
      fontSize: '16px ',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '15px ',
    },
    [theme.breakpoints.only('lg')]: {
      fontSize: '14px ',
    },
    [theme.breakpoints.only('xl')]: {
      fontSize: '18px ',
    },
  },
  flexGrow: {
    flexGrow: 1,
  },
  flexGrowShrinkBasis: {
    flex: '1 0 0',
    wordBreak: 'break-all',
  },
  mainHeading: {
    fontWeight: 700,
    color: textColor,
    textTransform: textTransformCapitalize,
    [theme.breakpoints.only('xs')]: {
      fontSize: '28px ',
    },

    [theme.breakpoints.only('sm')]: {
      fontSize: '26px ',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '22px ',
    },
    [theme.breakpoints.only('lg')]: {
      fontSize: '20px ',
    },
    [theme.breakpoints.only('xl')]: {
      fontSize: '18px ',
    },
  },

  statusHeading: {
    fontWeight: 600,

    textTransform: textTransformCapitalize,
    [theme.breakpoints.only('xs')]: {
      fontSize: '16px ',
    },

    [theme.breakpoints.only('sm')]: {
      fontSize: '16px ',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '17px ',
    },
    [theme.breakpoints.only('lg')]: {
      fontSize: '18px ',
    },
    [theme.breakpoints.only('xl')]: {
      fontSize: '18px ',
    },
  },
  statusSubHeading: {
    fontWeight: 400,
    color: statusSubHeading,
    textTransform: textTransformCapitalize,
    [theme.breakpoints.only('xs')]: {
      fontSize: '12px ',
    },

    [theme.breakpoints.only('sm')]: {
      fontSize: '12px ',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '13px ',
    },
    [theme.breakpoints.only('lg')]: {
      fontSize: '14px ',
    },
    [theme.breakpoints.only('xl')]: {
      fontSize: '15px ',
    },
  },
  secondHeading: {
    fontWeight: 600,
    color: textColor,
    textTransform: textTransformCapitalize,
    [theme.breakpoints.only('xs')]: {
      fontSize: '16px ',
    },

    [theme.breakpoints.only('sm')]: {
      fontSize: '16px ',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '16px ',
    },
    [theme.breakpoints.only('lg')]: {
      fontSize: '16px ',
    },
    [theme.breakpoints.only('xl')]: {
      fontSize: '18px ',
    },
  },
  thirdHeading: {
    fontWeight: 500,
    color: textColor,
    textTransform: textTransformCapitalize,
    [theme.breakpoints.only('xs')]: {
      fontSize: '14px ',
    },

    [theme.breakpoints.only('sm')]: {
      fontSize: '14px ',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '14px ',
    },
    [theme.breakpoints.only('lg')]: {
      fontSize: '14px ',
    },
    [theme.breakpoints.only('xl')]: {
      fontSize: '16px ',
    },
  },

  dropDownMenuActive: {
    background: '#4ea5e7',
    color: '#fff',
    "&:hover": {
      background: '#4ea5e7',
      color: '#fff',
    },
    '& div': {
      '& svg': {
        fill: '#fff'
      }
    },
  },

  cursorPointer: {
    cursor: 'pointer',
  },
  powerBiContainer : {
    display : "flex",
    flexBasis: "column",
    height: "1000px"
  },

  memoNullControl: {
    margin: 0,
    padding: "4px 10px",
    border: "1px solid #d5d9df",
    borderRadius: 4,
    backgroundColor: "#fff",

    "& .MuiFormControlLabel-label": {
      fontSize: 13,
      fontWeight: 500,
      color: "#424242",
    },

    "& .MuiCheckbox-root": {
      padding: 3,
      marginLeft: 4,
      marginRight: 6,
    },

    "&:hover": {
      borderColor: "#000000ff",
      backgroundColor: "#f8f9ff",
    },
  },
}));
export default useStyles;
